// Latin digits in both languages, matching the rest of the site (a lone Arabic ٠ reads as a dot).
export const formatNumber = (value: number) => value.toLocaleString("en-US");
